import modalclose from "../images/modalclose.svg";

const PhoneConfirmationModal = ({
  isOpen,
  onClose,
  phoneNumber,
  onConfirm,
  onEdit,
}) => {
  if (!isOpen) return null;

  const formatPhoneNumber = (phone) => {
    return `+251 ${phone}`;
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 flex justify-center items-center z-50"
      role="dialog"
      aria-modal="true"
    >
      <div className="h-full w-full overflow-y-auto flex justify-center items-center pt-10 mb-5">
        <div
          className="relative w-full h-full max-w-[500px] animate-fade-in"
          tabIndex={0}
        >
          <div className="px-[15px]">
            <div className="bg-shadeGreen p-[32px_30px] rounded-[8px_8px_0px_0px] relative overflow-auto border-l-2 border-t-2 border-r-2 border-[#33494E]">
              <div className="flex justify-between items-start pb-[10px] mb-5 border-b-[1px] border-[#33494E]">
                <div className="flex flex-col gap-3">
                  <h4 className="text-white text-2xl font-medium">
                    CONFIRM YOUR PHONE NUMBER
                  </h4>
                  <p className="text-[#8DA0A9] text-sm md:text-base font-normal">
                    Please confirm your phone number is correct
                  </p>
                </div>
                <button
                  onClick={onClose}
                  className="w-[38px] h-[38px] min-w-[38px] flex justify-center items-center border-[1px] rounded-md border-[#33494E] bg-[rgba(0, 0, 0, 0.3)] hover:bg-[rgba(0, 0, 0, 0.5)] transition-all duration-[0.4s]"
                >
                  <img src={modalclose} alt="close" />
                </button>
              </div>

              <div className="space-y-6">
                {/* Phone number display */}
                <div className="flex flex-col items-center">
                  <p className="text-[#8DA0A9] text-base mb-2">
                    Your phone number
                  </p>
                  <div className="text-white text-2xl font-medium">
                    {formatPhoneNumber(phoneNumber)}
                  </div>
                </div>

                <div className="text-center text-[#8DA0A9] text-sm mt-4">
                  <p>Make sure your phone number is correct.</p>
                  <p>You will use this number to log in to your account.</p>
                </div>

                {/* Buttons */}
                <div className="flex flex-col gap-4 mt-6">
                  <button
                    onClick={onConfirm}
                    className="w-full bg-yellow hover:bg-[#3D8089] py-4 text-white font-medium rounded-md transition-all duration-300"
                  >
                    CONFIRM & CONTINUE
                  </button>
                  <button
                    onClick={onEdit}
                    className="w-full bg-buttonGradient bg-no-repeat text-white hover:text-white hover:border-[#1b4334] hover:bg-buttonGradientHover py-4 font-medium rounded-md transition-all duration-300"
                  >
                    EDIT PHONE NUMBER
                  </button>
                </div>
              </div>
            </div>

            {/* Disclaimer */}
            <div className="bg-[#061015] text-[#8DA0A9] text-sm text-center py-3 rounded-[0px_0px_8px_8px] border-l-2 border-r-2 border-b-2 border-[#33494E] border-t-0">
              You must be 18 yrs and above in order to sign up.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhoneConfirmationModal;
